<template>
  <div>
    <el-collapse v-model="activeNames" style="border: none;">
      <el-collapse-item title="订单查询" name="1" style="margin: 0px 20px 0 20px;padding: 20px;">
        <el-form :inline="true" label-width="110px" style="padding: 20px 0 0 0; border-top: 1px solid #f1f1f1;">
          <el-form-item label="订单类别选择:" style="margin-left: 10px;">
            <el-select v-model="ordertype" filterable placeholder="请选择订单分类" @change="ordertypechange">
              <el-option
                v-for="item in ordertypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态选择:" style="margin-left: 10px;">
            <el-select v-model="orderstate" filterable placeholder="请选择订单状态" @change="orderstatechange">
              <el-option
                v-for="item in orderstatelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单日期:" style="margin-left: 10px;">
            <el-date-picker
              v-model="byorderdate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div style="display: flex;flex-flow: row;">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="queryall">查询订单</el-button>
          <el-button style="margin-left: 10px;" type="success" icon="el-icon-download" @click="outputorder">导出订单详情</el-button>
          <!--
            <el-button style="margin-top: 10px; margin-left: 10px;" @click="importset">导入配置</el-button>
          <el-upload
            ref="upload"
            style="margin-top: 10px; margin-left: 10px;"
            action="/"
            :show-file-list="false"
            :on-change="importExcel"
            :auto-upload="false">
            <el-button
              icon="el-icon-upload"
              type="primary">
              导入配送单
            </el-button>
          </el-upload>
          -->
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-tabs v-model="activeName" type="card" style="margin: 0 40px 0 40px;">
      <el-tab-pane label="订单视图" name="orderview">
        <div id="mymainChart" class="card"></div>
      </el-tab-pane>
      <el-tab-pane label="订单信息" name="orderinfo">
        <div style="margin-top: 10px;width:100%;display: flex;flex-flow:row;justify-content: center;align-items: center;">
          <el-pagination
            ref="elpage"
            @size-change="sizechange"
            @current-change="curpagehange"
            :current-page="currentPage"
            :page-sizes="[size]"
            :page-size=size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
        <el-table
          stripe
          id="orderdataid"
          :header-cell-style="{'text-align':'center'}"
          :data="orderdata"
          ref="multipleTable">
          <el-table-column
            prop="order_no"
            label="订单列表">
            <template slot-scope="scope">
              <el-card class="box-card" style="width: 100%; ">
                <div slot="header" style="display: flex; height: 32px;padding: 0 10px 0 10px; flex-direction: row; align-items: center; justify-content: space-between;" >
                  <div style="float: right; padding: 3px 0">
                    <div v-if="scope.row.state_id === 1">待付款</div>
                    <div v-if="scope.row.state_id === 2">已付款待发货</div>
                    <div v-if="scope.row.state_id === 3">已发货待确认</div>
                    <div v-if="scope.row.state_id === 4">已确认</div>
                    <div v-if="scope.row.state_id === 5">已评价</div>
                    <div v-if="scope.row.state_id === 6">已分账</div>
                    <div v-if="scope.row.state_id === 9">已取消</div>
                  </div>
                </div>
                <div style="display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between;" >
                  <div style="display: flex; flex-direction: row;">
                    <div v-if="scope.row.ordergoods !== null">
                      <div v-for="(item,index) in scope.row.ordergoods.split('|')" :key="index" >
                        <div v-if="item !== ''" style="display: flex; flex-direction: row; margin-bottom: 20px;">
                          <div>
                            <img style="width: 128px;height:128px; border-radius: 10px;" :src="item.split('&')[2]">
                          </div>
                          <div style="width: 50%; display: flex; flex-direction: column;margin-left: 40px;">
                            <div>产品名： {{item.split('&')[0]}}</div>
                            <div>数量： {{item.split('&')[1]}}</div>
                            <div v-if="item.split('&')[3] !== ''">规格：
                              <div  v-for="(subitem,index) in item.split('&')[3].split(',')" :key="index">
                                <span style="margin-left:40px;">{{subitem}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="scope.row.userphone !== null && scope.row.userphone !== ''" style="width: 40%; display: flex; flex-direction: column;margin-left: 20px;">
                      <div>下单人： {{scope.row.username}}</div>
                      <div>下单地址： {{scope.row.format_address}}</div>
                      <div>联系方式： {{scope.row.userphone}}</div>
                    </div>
                  </div>
                </div>
                <div>订单备注：{{scope.row.uword}}</div>
                <div>费用： {{scope.row.count_price}}, 支付单号： {{scope.row.wxpayno}}</div>
                <div style="margin-top: 20px; display: flex; flex-direction: row;  justify-content: space-between">
                  <span>订单号：{{scope.row.order_no}} <span style="margin-left: 10px; color: darkred;" v-if="scope.row.sfno !== null && scope.row.sfno !== ''">  快递单号：{{scope.row.sfno}}</span> <i @click="querysfstate(scope.$index, orderdata)" class="el-icon-view"></i> </span>
                  <span>下单时间：{{scope.row.op_time}}</span>
                </div>
              </el-card>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120px"
          >
            <template slot-scope="scope">
              <div style="width: 120px; display: flex;align-items: center; justify-content: center;">
                <el-tooltip class="item" effect="dark" content="查看订单详情" placement="top-start">
                  <i class="fa el-icon-document fa-lg ciicon curpointer" v-on:click="seeorder(scope.$index, orderdata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="更改价格" placement="top-start">
                  <i class="fa el-icon-sort fa-lg ciicon curpointer" v-on:click="changeprice(scope.$index, orderdata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="发货" placement="top-start" :hidden="ifhiddentruck">
                  <i class="fa fa-truck fa-lg ciicon curpointer" v-on:click="sendorder(scope.$index, orderdata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="查看物流" placement="top-start" :hidden="ifhiddenqueren || ifhiddenqueren">
                  <i class="fa fa-check-circle-o fa-lg ciicon curpointer" v-on:click="lookwl(scope.$index, orderdata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="确认到货" placement="top-start" :hidden="ifhiddenqueren">
                  <i class="fa fa-check-circle-o fa-lg ciicon curpointer" v-on:click="okorder(scope.$index, orderdata)"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="订单详情" width="70%" :visible.sync="orderdetailvisible">
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="订单编号:">{{orderdetaildata.order_no}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="下单日期:">{{orderdetaildata.op_time}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="下单人手机:">{{orderdetaildata.phone}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="订单状态:">{{orderdetaildata.state_id}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="24">
            <div class="queryinput">
              <el-form-item label="订单备注:">{{orderdetaildata.uword}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <div class="showpcinfo" style="margin-top: 10px;">
        <el-table
          stripe
          showSummary
          :header-cell-style="{'text-align':'center'}"
          :data="ordergoodsdata"
          ref="multipleTable">
          <el-table-column
            label="图片">
            <template slot-scope="scope">
              <div v-if="scope.row.imgurl && scope.row.imgurl !== ''">
                <img :src="scope.row.imgurl" class="goodsavatarimg">
              </div>
              <div v-else>
                {{scope.row.imgurl}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            width = "280px"
            label="商品名称">
          </el-table-column>
          <el-table-column
            prop="specinfo"
            label="规格">
          </el-table-column>
          <el-table-column
            prop="price"
            label="单价">
          </el-table-column>
          <el-table-column
            prop="count"
            label="数量">
          </el-table-column>
          <el-table-column
            prop="mztxt"
            label="赠品信息">
          </el-table-column>
          <el-table-column
            label="总价"
            width="80px"
          >
            <template slot-scope="scope">
              {{scope.row.count*scope.row.price}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-row style="flex:1;color: #000; margin-top: 40px;">
        <el-form>
          <el-col :span="24">
            <div class="queryinput">
              <el-form-item label="收货地址:"></el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="收货人姓名:">{{orderdetaildata.username}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="联系方式:">{{orderdetaildata.userphone}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="所属省市:">{{orderdetaildata.province}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="邮编:">{{orderdetaildata.adcode}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="24">
            <div class="queryinput">
              <el-form-item label="详细地址:">{{orderdetaildata.format_address}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-button style="margin-top: 20px" @click="delorder">作废订单</el-button>
    </el-dialog>
    <el-dialog title="订单详情" :visible.sync="ordershvisible">
    <div class="showpcinfo">
      <el-table
        stripe
        :data="ordershdata"
        ref="multipleTable">
        <el-table-column
          prop="username.String"
          width = "280px"
          label="收货人">
        </el-table-column>
        <el-table-column
          prop="shengname.String"
          label="省">
        </el-table-column>
        <el-table-column
          prop="shiname.String"
          label="市">
        </el-table-column>
        <el-table-column
          prop="address.String"
          label="收货地址">
        </el-table-column>
        <el-table-column
          prop="contact.String"
          label="联系方式">
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
    <el-dialog title="物流发货" :visible.sync="wuliuvisible">
      <div style="margin-left: 10px;font-size: 14px; color: #000;">
        access_token: <span style="margin-left: 10px; color: darkgreen;">{{jstaccesstoken}}</span>
      </div>
      <div class="showpcinfo">
        <el-form  label-width="120px">
          <el-row class="querypanel">
            <el-col :span="12">
              <el-form label-width="120px" label-position="left">
                <el-form-item label="订单编号:">
                  <el-input v-model="ddno" placeholder="请输入标题"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form label-width="120px" label-position="left" style="margin-left: 20px;">
                <el-form-item label="物流公司选择:">
                  <el-select v-model="wuliuinfo" filterable placeholder="请选择物流公司" >
                    <el-option
                      v-for="item in wuliulist"
                      :key="item.id"
                      @click.native ="selwlinfo(item)"
                      :label="item.wlinfo"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="物流单号:" >
                  <el-input v-model="wlno" placeholder="请输入物流单号"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="物流费用(元):" style="margin-left: 20px;">
                  <el-input v-model="wlprice" placeholder="请输入物流费用"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <div class="showpcinfo" style="margin-top: 10px;">
            <el-table
              stripe
              showSummary
              :header-cell-style="{'text-align':'center'}"
              :data="ordergoodsdata"
              ref="multipleTable">
              <el-table-column
                label="图片">
                <template slot-scope="scope">
                  <div v-if="scope.row.imgurl && scope.row.imgurl !== ''">
                    <img :src="scope.row.imgurl" class="goodsavatarimg">
                  </div>
                  <div v-else>
                    {{scope.row.imgurl}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                width = "280px"
                label="商品名称">
              </el-table-column>
              <el-table-column
                prop="specinfo"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="price"
                label="单价">
              </el-table-column>
              <el-table-column
                prop="count"
                label="数量">
              </el-table-column>
              <el-table-column
                prop="mztxt"
                label="赠品信息">
              </el-table-column>
              <el-table-column
                label="总价"
                width="80px"
              >
                <template slot-scope="scope">
                  {{scope.row.count*scope.row.price}}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="color: #000; margin: 20px 0 20px 20px;">支付时间: {{zftime}} 支付单号: {{zfno}} 支付金额：{{zfprice}}</div>
          <div style="color: #000; margin: 10px; border-radius: 10px; border: 1px solid #00a67c; padding: 20px;">
            <div style="margin-top: 10px;">云仓相关功能</div>
            <div style="margin-left: 20px;">
              <el-button style="margin-top: 20px" @click="sendtows">同步订单到云仓</el-button>
              <el-button style="margin-top: 20px" @click="makepayorder">生成调拨支付单号</el-button>
              <el-button style="margin-top: 20px" @click="changefhstate">手动更新为发货状态</el-button>
            </div>
            <div style="margin-top: 20px;">虚拟发货，直接更新微信后台</div>
            <el-button style="margin-top: 20px; margin-left: 20px;" @click="sendxni">虚拟发货</el-button>
            <div style="margin-top: 20px;">厂家直接发货/非中通发货</div>
            <el-button style="margin-top: 20px; margin-left: 20px;" @click="thirdsend">厂家直接发货</el-button>
            <el-button style="margin-top: 20px" @click="syncweixin">同步微信后台</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="物流信息" :visible.sync="wlddvisiable">
      <div class="showpcinfo">
        <el-table
          stripe
          :data="wuliuorder"
          ref="multipleTable">
          <el-table-column
            prop="orderno"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="threename.String"
            label="三方物流名称">
          </el-table-column>
          <el-table-column
            prop="logisticsno.String"
            label="物流单号">
          </el-table-column>
          <el-table-column
            prop="address.String"
            label="费用">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog title="导入配置" :visible.sync="importsetvis">
      <el-button style="margin-top: 10px" @click="downtemp">下载导入模板</el-button>
      <div style="color: #8a8a8a; margin-left: 5px; margin-top: 20px;margin-bottom: 10px;">物流公司ID参考：</div>
      <div class="showpcinfo">
        <el-table
          stripe
          :data="wlgsdata"
          ref="multipleTable">
          <el-table-column
            prop="id.Int64"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="lname"
            label="物流名称">
          </el-table-column>
          <el-table-column
            prop="lcontact"
            label="物流单号">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
import Utils from '../../util/utils'
import ElForm from '../../../node_modules/element-ui/packages/form/src/form'
import ElFormItem from '../../../node_modules/element-ui/packages/form/src/form-item'
import XLSX from 'xlsx'
import { Dialog } from 'vant';
// 全局注册
Vue.use(Dialog);
Vue.prototype.$http = axios
var that
export default {
  components: {
    ElFormItem,
    ElForm},
  name: 'OrderInfo',
  data () {
    return {
      curorderno: '',
      curorderdate: '',
      zftime: '',
      zfno: '',
      zfprice: '',
      activeName: 'orderview',
      curorderbuyuser: '',
      wlddvisiable: false,
      importsetvis: false,
      activeNames: ['1'],
      jstaccesstoken: '',
      wlgsdata: [],
      curorderstate: '',
      shzipcode: '',
      shname: '',
      shcontact: '',
      shssaddress: '',
      shaddressex: '',
      curorderdes: '',
      orderdata: [],
      ordershdata: [],
      ordergoodsdata: [],
      currentPage: 1,
      curpage: 1,
      size: 20,
      total: 0,
      byorderdate: '',
      orderdetaildata: '',
      ifhiddentruck: true,
      ifhiddenqueren: true,
      wuliuvisible: false,
      ddno: '',
      wlno: '',
      wlprice: '',
      xfcount: '',
      viplevels: '',
      buyuserid: '',
      ordertypelist: [{
        value: 0,
        label: '所有订单'
      }, {
        value: 1,
        label: '销售订单'
      }, {
        value: 4,
        label: '采购订单'
      }, {
        value: 9,
        label: '预售卡订单'
      }],
      ordertype: '',
      orderstate: '',
      automlevel: '0',
      sendorderinfo: '', // 发货订单
      orderdetailvisible: false,
      ordershvisible: false,
      wuliulist: [],
      curaccesstoken: '',
      wuliuinfo: '中通物流',
      wuliuid: '3',
      wuliuorder: [],
      orderexdata: [],
      orderstatelist: [{
        value: 0,
        label: '所有状态'
      }, {
        value: 1,
        label: '待付款'
      }, {
        value: 2,
        label: '已付款待发货'
      }, {
        value: 3,
        label: '已发货待确认'
      }, {
        value: 4,
        label: '已确认'
      }, {
        value: 5,
        label: '已评价'
      }, {
        value: 6,
        label: '已分账'
      }, {
        value: 9,
        label: '已取消'
      }]
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      that.getwlinfo()
      that.get1taoaccess()
      that.getminproaccess()
    }
  },
  methods: {
    thirdsend () {
      let addtime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
      var wldata = {
        orderno: this.ddno,
        logisticsno: this.wlno,
        lineno: '',
        threeid: this.wuliuid.toString(),
        threename: this.wuliuinfo.toString(),
        price: '',
        sendtime: addtime,
        cusid: that.khid
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/addorderlogistics',
        method: 'post',
        data: wldata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            that.$message({
              type: 'success',
              message: '物流信息保存完毕!'
            })
            console.log(JSON.parse(res.data.data))
            console.log('更新订单状态')
            that.orderstatechange(that.ddno,3)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    syncweixin () {},
    getminproaccess () {
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/getdaccesstoken',
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          window.console.log(res)
          that.curaccesstoken = res.data
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    sendxni () {
      var tmpdata = this.sendorderinfo
      window.console.log(tmpdata)
      var date = new Date(tmpdata.op_time);
      var isotime = date.toISOString();
      var upata = {
        access_token: that.curaccesstoken,
        wldata: {
          order_key: {
            order_number_type: 2,
            transaction_id: tmpdata.wxpayno,
            out_trade_no: tmpdata.orderno,
            mchid: '1573495261'
          },
          delivery_mode: 1,
          logistics_type: 4,
          shipping_list: [
            {
              tracking_no: tmpdata.logisticsno,
              express_company: tmpdata.wxwlbz,
              item_desc: '黄小醺黄酒'
            }
          ],
          upload_time: isotime,
          payer: {
            openid:tmpdata.buy_cus_id
          }
        }
      }
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/uploadShippingInfo',
        method: 'post',
        data: upata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          window.console.log(res)
          if (res.data.data.errcode === 0) {
            that.$message.success('同步成功')
          } else {
            that.$message.error('同步失败,' + res.data.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    makepayorder () {
      let dateTime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
      var qstr = {
        orderno: that.ddno,
        wxpayno: 'WX' + that.ddno,
        wxpayprice: '1',
        wxpaydate: dateTime,
        ifrefuse: '0'
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/makepayorder',
        method: 'post',
        data: qstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          window.console.log(res)
          if (res.data.result === 'success') {
            that.querywxpay()
          } else {
            that.$message.error('增加支付订单失败')
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    get1taoaccess () {
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/get1taoaccesstoken',
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          window.console.log(res)
          that.jstaccesstoken = res.data
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    selwlinfo (item) {
      window.console.log(item)
      that.wuliuinfo = item.wlinfo
      that.wuliuid = item.id
    },
    sendtows () {
      window.console.log(that.sendorderinfo)
      if (that.ordergoodsdata !== '' && that.ordergoodsdata.length > 0) {
        that.makeorderex(that.sendorderinfo,that.ordergoodsdata)
      }
    },
    getwlinfo () {
      var qstr1 = 'cusid = 1'
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querywlinfo',
        method: 'post',
        data: {
          whereinfo: qstr1,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.wuliulist = res.data
          } else {
            that.wuliulist = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    ordercancel (orderno) {
      var jsondata =
        {
          stock_id: '220126',
          shop_id: '254776',
          order_no: orderno,
          remark: ''
        }
      var qstr = {
        param_json: JSON.stringify(jsondata),
        v_method: 'cancelTrade',
        if_new: '1'
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/runky',
        method: 'post',
        data: qstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    makeorderex (ordertmp,goodstmp) {
      var orderinfos = [
        {
          'shop_id':15846245,
          'so_id':ordertmp.order_no,
          'order_date':ordertmp.op_time,
          'shop_status':'WAIT_SELLER_SEND_GOODS',
          'shop_buyer_id':ordertmp.ownphone, //  购买人
          'receiver_state':ordertmp.province, //  接收状态
          'receiver_city':ordertmp.city, //  接收城市
          'receiver_district':ordertmp.district, //  接收街道
          'receiver_address':ordertmp.format_address, // 地址
          'receiver_name':ordertmp.username, // 收货人
          'receiver_phone':ordertmp.userphone, // 联系方式
          'receiver_zip':ordertmp.adcode, // 邮编
          'pay_amount':parseInt(0), // 应付金额
          'freight':0, // 运费
          'remark':ordertmp.uword, // 备注
          'buyer_message':ordertmp.uword, //  购买信息
          'shop_modified':'', // 订单修改日期
          'l_id':'', // 快递单号
          'logistics_company':'', // 快递公司
          'labels':'',
          'lc_id':''
        }
      ]
      var skus = []
      for (var i = 0; i < goodstmp.length; i++) {
        var tmpgood = goodstmp[i]
        var sku = {
          'sku_id':tmpgood.barcode.toString(), // 产品ID
          'shop_sku_id':tmpgood.barcode, // SD
          'amount':tmpgood.count * parseInt(tmpgood.price), // 多少件
          'base_price':parseInt(0),
          'qty':tmpgood.count,
          'name':tmpgood.name,
          'outer_oi_id':ordertmp.order_no + i,
          'batch_id': '',
          'produced_date': ''
        }
        skus.push(sku)
      }
      orderinfos[0].items = skus
      var payitems = {
          'outer_pay_id': that.zfno,
          'pay_date':that.zftime,
          'payment':'微信',
          'seller_account':that.zfprice,
          'buyer_account':that.zfprice,
          'amount':parseInt(that.zfprice)
      }
      orderinfos[0].pay = payitems
      window.console.log(orderinfos)
      var qstr = {
        access_token: this.jstaccesstoken,
        param_json: JSON.stringify(orderinfos),
        v_method: '/open/jushuitan/orders/upload',
        if_new: '1'
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/runjst',
        method: 'post',
        data: qstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          window.console.log(res)
          that.$message.info(JSON.stringify(res.data.data))
          that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          if (res.data.result === 'success') {
            that.orderstatechange(ordertmp.order_no,3)
          } else {

          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    makeorder (ordertmp,goodstmp) {
      var orderinfos = [{
        order_no: ordertmp.order_no, // 导入订单号
        stock_id: '220126', // 网仓仓库Id
        transporter_flag: '0', // 是否已指定快递
        transporter_id: '',
        waybill_type:'',
        send_flag:'0', // 是否下发发货指令0否,1是
        shop_id: '254776', // 店铺ID
        order_create_time: ordertmp.op_time, // 拍单时间
        order_pay_time: ordertmp.op_time, // 付款时间
        buyer_nick:'1', // 买家昵称
        receiver_country:'中国', // 收货人国家
        receiver_province: ordertmp.province, // 省
        receiver_city: ordertmp.city, // 市
        receiver_county: ordertmp.district, // 县/区
        receiver_address:ordertmp.format_address, // 地址
        receiver_zip:'',
        receiver_name:ordertmp.username, // 收件人姓名
        receiver_mobile:ordertmp.userphone, // 收件人移动电话
        receiver_phone:ordertmp.userphone,
        request_ship_date:'',
        need_invoice:'0', // 是否需要发票
        invoice_name:'',
        invoice_content:'',
        payment:'',
        total_fee: ordertmp.count_price.toString(),
        discount_fee:'',
        post_fee:'',
        need_card:'0', // 需要贺卡
        card_content:'',
        create_date:'',
        buyer_message:ordertmp.uword,
        seller_memo:ordertmp.uword
      }]
      var skus = []
      for (var i = 0; i < goodstmp.length; i++) {
        var tmpgood = goodstmp[i]
        var sku = {
          product_code: tmpgood.barcode, // 条码
          qty: tmpgood.count.toString(), // 数量
          payment: '1',
          discount_fee: tmpgood.price,
          shop_id: '254776', // 店铺ID
          owner_id: '340120', //  货主ID
          sell_price: tmpgood.price
        }
        skus.push(sku)
      }
      orderinfos[0].skus = skus
      var jsondata = {
        count: 1, // 导入订单数
        trades: orderinfos
      }
      window.console.log(jsondata)
      var qstr = {
        param_json: JSON.stringify(jsondata),
        v_method: 'pushTrades',
        if_new: '1'
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/runky',
        method: 'post',
        data: qstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          that.$message.info(JSON.stringify(res.data.data))
          that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          window.console.log(that.resultstr)
          if (parseInt(that.resultstr.data.success_count) > 0) {
            that.orderstatechange(ordertmp.order_no,3)
          } else {

          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    changefhstate () {
      that.orderstatechange(that.ddno,3)
    },
    sizechange (val) {
      console.log('每页' + val + '条')
    },
    curpagehange (val) {
      that.queryrecpage(parseInt(val) - 1)
    },
    queryreccount () {
      var qstr = " ownphone='" + localStorage.getItem('username') + "'"
      if (this.ordertype !== null && this.ordertype !== '' && this.ordertype !== 0) {
        qstr = qstr + ' and type_id=' + this.ordertype
      }
      if (this.orderstate !== null && this.orderstate !== '' && this.orderstate !== 0) {
        qstr = qstr + ' and state_id=' + this.orderstate
      }
      if (this.byorderdate !== null && this.byorderdate !== '') {
        qstr = qstr + " and op_time >= '" + this.byorderdate[0] + " 00:00:00' and op_time<='" + this.byorderdate[1] + " 23:59:59'"
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryordercount',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ' order by op_time desc'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.total = res.data[0].count
          } else {
            that.total = 0
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryrecpage (val) {
      if (this.orderstate === 2) {
        this.ifhiddentruck = false
        this.ifhiddenqueren = true
      } else if (this.orderstate === 3) {
        this.ifhiddentruck = true
        this.ifhiddenqueren = false
      } else {
        this.ifhiddentruck = true
        this.ifhiddenqueren = true
      }
      var qstr = " ownphone='" + localStorage.getItem('username') + "'"
      if (this.ordertype !== null && this.ordertype !== '' && this.ordertype !== 0) {
        qstr = qstr + ' and type_id=' + this.ordertype
      }
      if (this.orderstate !== null && this.orderstate !== '' && this.orderstate !== 0) {
        qstr = qstr + ' and state_id=' + this.orderstate
      }
      if (this.byorderdate !== null && this.byorderdate !== '') {
        qstr = qstr + " and op_time >= '" + this.byorderdate[0] + " 00:00:00' and op_time<='" + this.byorderdate[1] + " 23:59:59'"
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorderinfoex',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: ' limit ' + val*that.size + ',' + that.size,
          sortinfo: ' order by op_time desc'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            window.console.log(res.data)
            that.orderdata = res.data
          } else {
            that.orderdata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    drawLine (tmpdata) {
      var xdata = []
      var ydata = []
      for (var i = 0; i < tmpdata.length; i++) {
        xdata.push(tmpdata[i].op_time)
        ydata.push(tmpdata[i].count_price)
      }
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById('mymainChart'))
      // 绘制图表
      myChart.setOption({
        legend: {
          data: ['业绩金额']
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xdata
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: ydata,
          type: 'line'
        }]
      })
      window.onresize = myChart.resize
    },
    downtemp () {
      var xlsdata = []
      var xlstmp = {
        '订单号': '',
        '物流单号': '',
        '物流公司ID': '',
        '费用': '',
        '发货时间': ''
      }
      xlsdata.push(xlstmp)
      window.console.log('订单导出信息')
      window.console.log(xlsdata)
      // 表名
      var ws = XLSX.utils.json_to_sheet(xlsdata);
      /* get binary string as output */
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '导入订单物流模板');
      /* 生成xlsx文件 */
      XLSX.writeFile(wb, '导入订单物流模板.xlsx');
    },
    getwlgsdata () {
      var qstr = 'id > 0'
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/gotl',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.wlgsdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    importset () {
      this.importsetvis = true
    },
    file2Xce(file) {
      return new Promise(function(resolve, reject) {
        const reader = new FileReader()
        reader.onload = function(e) {
          const data = e.target.result
          this.wb = XLSX.read(data, {
            type: 'binary'
          })
          const result = []
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            })
          })
          resolve(result)
        }
        reader.readAsBinaryString(file.raw)
        // reader.readAsBinaryString(file)     //使用原始input方法
      })
    },
    importExcel (file) {
      const types = file.name.split('.')[1]
      const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
      if (!fileType) {
        this.$message('格式错误！请重新选择')
        return
      }
      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson
          console.log('数据:', this.xlsxJson)
          var idatas = []
          for (var i = 0; i < this.xlsxJson[0].sheet.length; i++) {
              var tmpdata = this.xlsxJson[0].sheet[i]
              var fhtime = ''
              if (tmpdata.发货时间) {
                fhtime = tmpdata.发货时间
              }
              var adata = {
                orderno: tmpdata.订单号,
                logisticsno: {String: tmpdata.物流单号, Valid: true},
                threeid: {Int64: parseInt(tmpdata.物流公司ID), Valid: true},
                price: {String: tmpdata.费用.toString(), Valid: true},
                sendtime: {String: fhtime, Valid: true},
                cusid: parseInt(that.khid)
              }
            idatas.push(adata)
          }
          window.console.log(idatas)
          that.$http({
            url: 'https://api.sqnetsoft.cn/order/paaubol',
            method: 'post',
            data: idatas,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.success) {
                that.$message({
                  type: 'success',
                  message: '配送信息导入完毕!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      })
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价'
          return
        }
        if (index === 5) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ' 个'
          } else {
            sums[index] = 'N/A'
          }
        }
        if (index === 6) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ' 元'
          } else {
            sums[index] = 'N/A'
          }
        }
      })
      return sums
    },
    queryall () {
      this.queryorder()
      this.queryreccount()
      this.queryorderdesc()
    },
    queryorderdesc () {
      console.log('订单状态发生改变')
      if (this.orderstate === 2) {
        this.ifhiddentruck = false
        this.ifhiddenqueren = true
      } else if (this.orderstate === 3) {
        this.ifhiddentruck = true
        this.ifhiddenqueren = false
      } else {
        this.ifhiddentruck = true
        this.ifhiddenqueren = true
      }
      var qstr = " ownphone='" + localStorage.getItem('username') + "'"
      if (this.ordertype !== null && this.ordertype !== '' && this.ordertype !== 0) {
        qstr = qstr + ' and type_id=' + this.ordertype
      }
      if (this.orderstate !== null && this.orderstate !== '' && this.orderstate !== 0) {
        qstr = qstr + ' and state_id=' + this.orderstate
      }
      if (this.byorderdate !== null && this.byorderdate !== '') {
        qstr = qstr + " and op_time >= '" + this.byorderdate[0] + " 00:00:00' and op_time<='" + this.byorderdate[1] + " 23:59:59'"
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorderinfoex',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: ' limit 0,' + that.size,
          sortinfo: ' order by op_time desc'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            window.console.log(res.data)
            that.orderdata = res.data
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryorder () {
      console.log('订单状态发生改变')
      if (this.orderstate === 2) {
        this.ifhiddentruck = false
        this.ifhiddenqueren = true
      } else if (this.orderstate === 3) {
        this.ifhiddentruck = true
        this.ifhiddenqueren = false
      } else {
        this.ifhiddentruck = true
        this.ifhiddenqueren = true
      }
      var qstr = " ownphone='" + localStorage.getItem('username') + "'"
      if (this.ordertype !== null && this.ordertype !== '' && this.ordertype !== 0) {
        qstr = qstr + ' and type_id=' + this.ordertype
      }
      if (this.orderstate !== null && this.orderstate !== '' && this.orderstate !== 0) {
        qstr = qstr + ' and state_id=' + this.orderstate
      }
      if (this.byorderdate !== null && this.byorderdate !== '') {
        qstr = qstr + " and op_time >= '" + this.byorderdate[0] + " 00:00:00' and op_time<='" + this.byorderdate[1] + " 23:59:59'"
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorderinfoex',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            window.console.log(res.data)
            that.drawLine(res.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    printorder () {},
    changeprice (index, data) {
      var pricedata = data[index]
      console.log(pricedata)
      this.$prompt('请输入新的价格', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        var qstr = "order_no ='" + pricedata.orderno + "'"
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/upboi',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            fieldparams: {String: ' count_price=' + value, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '已更新订单价格!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消价格变更'
        })
      })
    },
    seeordersh (index, data) {
      console.log(data[index])
      this.ordershvisible = true
    },
    seeorder (index, data) {
      var ddata = data[index]
      window.console.log(ddata)
      this.orderdetailvisible = true
      this.curorderno = ddata.order_no
      var qstr = " order_no ='" + ddata.order_no + "'"
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorderinfo',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            window.console.log('查看订单详情',res.data[0])
            that.orderdetaildata = res.data[0]
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorderdetail',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.ordergoodsdata = res.data
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    delorder () {
      this.$confirm('您确定要作废该订单嘛？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var qstr = "order_no ='" + that.curorderno + "'"
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/upboi',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            fieldparams: {String: ' state_id=9', Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '已更新订单状态!'
              })
              console.log(JSON.parse(res.data.data))
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      })
    },
    orderstatechange (orderno,state) {
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/uporderstate',
        method: 'post',
        data: {
          order_no: orderno,
          state_id: state.toString()
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            that.$message({
              type: 'success',
              message: '已更新订单状态!'
            })
            that.queryall()
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    ordertypechange () {},
    sendorder (index, data) {
      console.log(data[index])
      this.sendorderinfo = data[index]
      this.wuliuvisible = true
      this.ddno = data[index].order_no
      this.buyuserid = data[index].buycusid
      that.querywxpay()
      var qstr = " order_no ='" + this.ddno + "'"
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorderdetail',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.ordergoodsdata = res.data
          } else {
            that.ordergoodsdata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },

    okorder (index, data) {
      this.ddno = data[index].orderno
      this.$confirm('确定对订单 "' + this.ddno + '"进行确认收货吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        var qstr = "order_no ='" + that.ddno + "'"
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/upboi',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            fieldparams: {String: ' state_id=4', Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '已更新订单状态!'
              })
              if (that.orderstate === 2) {
                that.ifhiddentruck = false
                that.ifhiddenqueren = true
              } else if (that.orderstate === 3) {
                that.ifhiddentruck = true
                that.ifhiddenqueren = false
              } else {
                that.ifhiddentruck = true
                that.ifhiddenqueren = true
              }
              var qstr = ' sale_cus_id =' + that.khid
              if (that.ordertype !== null && that.ordertype !== '' && that.ordertype !== '0') {
                qstr = qstr + ' and type_id=' + that.ordertype
              }
              if (that.orderstate !== null && that.orderstate !== '' && that.orderstate !== '0') {
                qstr = qstr + ' and state_id=' + that.orderstate
              }
              if (that.byorderdate !== null && that.byorderdate !== '') {
                qstr = qstr + " and op_time >= '" + that.byorderdate[0] + " 00:00:00' and op_time<='" + that.byorderdate[1] + " 23:59:59'"
              }
              that.$http({
                url: 'https://api.sqnetsoft.cn/order/goi',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true},
                  sorinfo: {String: ' order by op_time desc', Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.orderdata = JSON.parse(res.data.data)
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
              console.log(JSON.parse(res.data.data))
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      })
    },
    lookwl (index, data) {
      this.wlddvisiable = true
      this.ddno = data[index].orderno
      var qstr = "orderno ='" + this.ddno + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/getbol',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            if (res.data.data === '[]') {
              that.wuliuorder = ''
            } else {
              that.wuliuorder = JSON.parse(res.data.data)
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querywxpay () {
      var qstr = "orderno ='" + this.ddno + "'"
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querywxpayorders',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ' order by id desc'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            var tmpdata = res.data[0]
            var datetmp = new Date(tmpdata.wxpaydate);
            // 或者自定义格式
            var customFormat = datetmp.getFullYear() + '-' +
              ('0' + (datetmp.getMonth() + 1)).slice(-2) + '-' +
              ('0' + datetmp.getDate()).slice(-2) + ' ' +
              ('0' + datetmp.getHours()).slice(-2) + ':' +
              ('0' + datetmp.getMinutes()).slice(-2) + ':' +
              ('0' + datetmp.getSeconds()).slice(-2);
            that.zftime = customFormat
            that.zfno = tmpdata.wxpayno
            that.zfprice = tmpdata.wxpayprice
          } else {
            that.zftime = ''
            that.zfno = ''
            that.zfprice = ''
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savekdinfo () {
      let addtime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
      var wldata = {
        orderno: this.ddno,
        logisticsno: this.wlno,
        lineno: '',
        threeid: this.wuliuid.toString(),
        threename: this.wuliuinfo.toString(),
        price: this.wlprice,
        sendtime: addtime,
        cusid: that.khid
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/addorderlogistics',
        method: 'post',
        data: wldata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            that.$message({
              type: 'success',
              message: '物流信息保存完毕!'
            })
            console.log(JSON.parse(res.data.data))
            console.log('更新订单状态')
            that.orderstatechange(that.ddno,3)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      // 处理会员数据
      console.log('处理会员数据')
      // 获取会员ID
      console.log(this.buyuserid)
      // 获取用户会员是否自动计费
      var qstr = "userid ='" + this.buyuserid + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/cardticket/getbmac',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success && res.data.data !== '[]') {
            var data = JSON.parse(res.data.data)
            if (data[0].ifautocard === 1) {
              console.log('自动会员计费')
              var qstr = 'buy_cus_id  = ' + that.buyuserid + ' and sale_cus_id= ' + that.khid + ' and state_id > 1'
              that.$http({
                url: 'https://api.sqnetsoft.cn/order/goc',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.xfcount = JSON.parse(res.data.data)
                    console.log('根据用户消费金额设定用户等级')
                    var qstr1 = 'cusid  = ' + that.khid
                    that.$http({
                      url: 'https://api.sqnetsoft.cn/cardticket/getbcl',
                      method: 'post',
                      data: {
                        whereinfo: {String: qstr1, Valid: true}
                      },
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    })
                      .then(function (res) {
                        if (res.data.success) {
                          console.log(JSON.parse(res.data.data))
                          that.viplevels = JSON.parse(res.data.data)
                          console.log('根据用户消费金额设定用户等级')
                          that.automlevel = -1
                          for (var i = 0; i < that.viplevels.length; i++) {
                            if (that.xfcount < that.viplevels[i].count) {
                              console.log(i)
                              console.log(that.xfcount)
                              console.log(that.viplevels[i].count)
                              if (i === 0) {
                                that.automlevel = 0
                              } else {
                                that.automlevel = that.viplevels[i].level - 1
                              }
                              break
                            }
                          }
                          if (that.automlevel === -1) {
                            that.automlevel = that.viplevels[that.viplevels.length - 1].level
                          }
                          console.log('当前级别：')
                          console.log(that.automlevel)
                          var whereinfo = ' userid = ' + that.buyuserid
                          var fieldparams = ' buycount=' + that.xfcount + ',levelid=' + that.automlevel
                          that.$http({
                            url: 'https://api.sqnetsoft.cn/cardticket/upbmc',
                            method: 'post',
                            data: {
                              fieldparams: {String: fieldparams, Valid: true},
                              whereinfo: {String: whereinfo, Valid: true}
                            },
                            headers: {
                              'Content-Type': 'application/json'
                            }
                          })
                            .then(function (res) {
                              if (res.data.success) {
                                that.$message({
                                  type: 'success',
                                  message: '已自动更新卡等级!'
                                })
                              }
                            })
                            .catch(function (error) {
                              console.log('error' + error)
                            })
                        }
                      })
                      .catch(function (error) {
                        console.log('error' + error)
                      })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            } else {
              console.log('手动计费')
            }
          } else {
            console.log('找不到会员信息')
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    outputorder () {
      var xlsdata = []
      for (var i = 0; i< that.orderexdata.length; i++) {
        var tmpdata = that.orderexdata[i]
        var xlstmp = {
          '订单号':tmpdata.orderno,
          '支付单号': tmpdata.tradeno.String,
          '订单类别': tmpdata.typeid,
          '订单状态': tmpdata.stateid,
          '购买用户ID': tmpdata.buycusid,
          '购买人名称': tmpdata.name.String,
          '购买人联系方式': tmpdata.phone.String,
          '销售方ID': tmpdata.salecusid,
          '销售方': tmpdata.salecusname.String,
          '订单总价': tmpdata.countprice,
          '订单备注': tmpdata.uword.String,
          '下单时间': tmpdata.optime
        }
        xlsdata.push(xlstmp)
        for (var j = 0; j< tmpdata.items.length; j++) {
          var tmpdata1 = tmpdata.items[j]
          var xqdd = {
            '品名': tmpdata1.name.String,
            '条码': tmpdata1.barcode.String,
            '规格': tmpdata1.specinfo.String,
            '价格': tmpdata1.price.String,
            '数量': tmpdata1.count.Int64
          }
          xlsdata.push(xqdd)
        }
      }
      window.console.log('订单导出信息')
      window.console.log(xlsdata)
      // 表名
      var ws = XLSX.utils.json_to_sheet(xlsdata);
      /* get binary string as output */
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '订单详情');
      /* 生成xlsx文件 */
      XLSX.writeFile(wb, '订单详情.xlsx');
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>
<style>
  .el-form-item {
    margin-bottom: 0px;
  }
  .card {
    height: 500px;
    width: 100%;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/OrderInfo.vue